module.exports = __webpack_public_path__ + "media/images/pic/customers-7523fe88c82e1c295f71266695bd15ee.jpg";